import { Widget } from '../Widget';
import { ModAccessProperties } from '../mods/modAccess';
import {
  ModBaseWidgetCallbacks,
  ModBaseWidgetProperties,
} from '../mods/modBaseWidget';
import { ModImportProperties } from '../mods/modImport';
import { ModProcessctlProperties } from '../mods/modProcessctl';

/** @internal */
export interface TestingToolProperties
  extends ModBaseWidgetProperties,
    ModProcessctlProperties,
    ModImportProperties,
    ModAccessProperties {}

/** @internal */
export type TestingToolCallbacks = ModBaseWidgetCallbacks;

/** @internal */
export class TestingTool extends Widget<
  TestingToolProperties,
  TestingToolCallbacks
> {
  /**
   * # Testing Tool
   * The Testing Tool widget will allow importing users’ accounts, choosing one
   * of them, and executing the payment. It will be provided to the testing
   * company, which will use it for testing accounts from different countries.
   *
   * @param container - parent HTML element where the widget will be injected
   * @param target - URL of the environment from which the widget's JS bundle will be fetched. Use this, for example, when testing features that are only released to the sandbox environment. By default, `https://widget-library-finapi-general-live.finapi.io` is used.
   * @param ownerDocument - parent Document where the widget will be injected. For example, shadow root or document fragment. By default, the default top-level document is used.
   * @param customBundleFileName - allows modifying the filename of the widget's JS bundle that will be fetched. This property is useful during dev mode when widgets are generated together into one `main.js` file.
   */
  constructor(
    container: HTMLElement,
    target?: string,
    ownerDocument?: Document,
    customBundleFileName?: string
  ) {
    super(
      'testingTool',
      container,
      target,
      ownerDocument,
      customBundleFileName
    );
  }
}
